module.exports = __webpack_public_path__ + "img/login-bg-judge.224794f4.png";